import React, { useEffect, useRef, useState } from "react";
import Navbar from "../common-component/navbar/Navbar";
import LeftSection from "../common-component/left-menu-section/LeftSection";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import useEmirateFromCoordinates, { BACKEND_URL } from "../common/Common";
import "../eventdetails/EventDetails.css";

import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
import leftarrow from '../../assets/offers/leftarrow.png';
import locationPin from "../../assets/event-details/locationpin.png";
import timer from "../../assets/event-details/timer.png";
import ticket from "../../assets/event-details/ticket.png";
import star from '../../assets/experience/star.png';
import locationPinblack from "../../assets/events/locationpin.png";

import popup_yatch from "../../assets/offers/popup_yatch.png";
import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';


const EventDetails = () => {
    const navigate = useNavigate();
    const navigatetoregisterpage = () => {
        navigate("/register");
    }
    const { eventId } = useParams();
    const [eventdetail, setEventDetail] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const sliderRef = useRef(null);
    const [mediaItems, setMediaItems] = useState([]);
    const [expand, setExpand] = useState(false);
    const [expanddetailstab, setExpandDetailsTab] = useState(false);
    const [activeTab, setActiveTab] = useState("Details");
    const hasAmenities = eventdetail[0]?.amenities?.length > 0;
    // MORE LESS CONCEPT - IT WILL DISAPPEAR IF TEXT COMES UNDER 2 LINES
    const [showToggle, setShowToggle] = useState(false);
    const descRef = useRef(null);
    const [getbrandlist, setGetbrandlist] = useState([]);
    const youMayLikeSliderRef = useRef(null);
    const [relatedevents, setRelatedEvents] = useState([]);
    const [vendoreventlist, setVendorEventList] = useState([]);
    const [eventlist, setEventList] = useState([]);
    const [isEventValid, setIsEventValid] = useState(false);
    //LAT LANG 
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [selectedStateId, setSelectedStateId] = useState(null);
    const emirate = useEmirateFromCoordinates(latitude, longitude);
    const [downloadPopupOpen, setDownloadPopupOpen] = useState(false);

    // Timer state
    const [timeRemaining, setTimeRemaining] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    const settings = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        centerMode: false,
        arrows: false,
        dots: false,
        swipe: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                    arrows: false,
                }
            }
        ]
    };

    const getSlidesToShow = () => {
        const width = window.innerWidth;
        if (width >= 993) return 3;      // Desktop
        if (width >= 769 && width <= 992) return 1.5;  // Tablet - show 1.5 cards
        if (width >= 320 && width < 769) return 1.5; // Mobile - show 1.5 cards
        return 1; // fallback
    };
    const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());

    useEffect(() => {
        const handleResize = () => setSlidesToShow(getSlidesToShow());
        window.addEventListener("resize", handleResize);

        // Immediately set correct value in case dev tools changed width before render
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const offerSettings = {
        infinite: slidesToShow >= 3, // Only infinite for desktop (3+ cards)
        slidesToShow,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        dots: false,
        centerMode: false,
        initialSlide: 0,
        swipe: true,
        swipeToSlide: true,
        touchMove: true,
        speed: 300,
        cssEase: "ease-out",
    };


    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const [day, month, year] = dateStr.split("-");
        const date = new Date(year, month - 1, day);

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const formatTime = (timeStr) => {
        if (!timeStr) return "";
        // Assuming time is in HH:MM format, convert to 12-hour format
        const [hours, minutes] = timeStr.split(":");
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 || 12;
        return `${hour12.toString().padStart(2, "0")}:${minutes} ${ampm}`;
    };

    // Handler to navigate and refresh page
    const handleEventClick = (e, eventId) => {
        e.preventDefault();
        window.location.href = `/eventdetails/${eventId}`;
    };

    const fetcheventlist = async () => {
        // Only proceed if we have coordinates
        if (latitude === null || longitude === null) {
            console.log("Waiting for coordinates...");
            return;
        }

        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            state_id: selectedStateId || emirate?.id || "",
            user_id: "",
        };
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-event-list`, payload);
            setEventList(response.data);
        } catch (error) {
            console.error("Error fetching Events List:", error);
        }
    }

    const fetcheventdetails = async (eventId) => {
        const payload = {
            login_user_id: 501,
            event_id: eventId,
        }
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-event-details`, payload);
            if (response.data && response.data.length > 0) {
                setEventDetail(response.data);
                setIsEventValid(true); // Optimistically set as valid if data is returned
            } else {
                setEventDetail([]);
                setIsEventValid(false);
            }
        } catch (error) {
            console.log("Error Fetching Event Detail", error);
            setEventDetail([]);
            setIsEventValid(false);
        }
    }

    // Check if event_id exists in eventlist
    const isEventIdInEventList = (eventId) => {
        if (!eventId || !Array.isArray(eventlist)) return false;
        return eventlist.some(event => Number(event.event_id) === Number(eventId));
    }
    const fetchGetbrandlist = async () => {
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-brand-list`, {
                latitude: 24.5,
                longitude: 54.4,
                page: 1,
                per_page: 1000,
            });

            const data = response.data.data || response.data;
            setGetbrandlist(data);
            return true;
        } catch (error) {
            console.error("Error fetching categories list:", error);
            return false;
        }
    }

    const matchedBrand = eventdetail[0]
        ? getbrandlist.find(
            (brand) => Number(brand.id) === Number(eventdetail[0].user_id)
        )
        : null;
    const state = matchedBrand?.state || "";
    const city = matchedBrand?.city || "";

    const fetchrelatedevents = async (eventId) => {
        if (latitude === null || longitude === null) {
            console.log("Waiting for coordinates...");
            return;
        }
        const payload = {
            event_id: eventId,
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            state_id: selectedStateId || emirate?.id || "",
        }
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-related-events`, payload);
            setRelatedEvents(response.data);
        } catch (error) {
            console.log("Error Fetching Related Events:", error);
        }
    }

    const fetchvendoreventlist = async (vendorUserId) => {
        if (!vendorUserId) {
            console.log("Vendor user_id not available");
            return;
        }
        const payload = {
            user_id: vendorUserId,
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
        }

        try {
            const response = await axios.post(`${BACKEND_URL}website/get-vendor-event-list`, payload);
            setVendorEventList(response.data);

        } catch (error) {
            console.log("Error Fetching Related Events:", error);
        }
    }


    useEffect(() => {
        if (descRef.current) {
            const el = descRef.current;
            const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
            const maxHeight = lineHeight * 2; // 2 lines
            if (el.scrollHeight > maxHeight) {
                setShowToggle(true);
            } else {
                setShowToggle(false);
            }
        }
    }, [eventdetail]);

    useEffect(() => {
        // Set defaults immediately for faster loading (don't wait for geolocation)
        setLatitude(24.4539);
        setLongitude(54.3773);

        // Check for stored state in localStorage
        const storedState = localStorage.getItem('selectedState');
        if (storedState) {
            try {
                const state = JSON.parse(storedState);
                setSelectedStateId(state.id);
                if (state.latitude) {
                    setLatitude(parseFloat(state.latitude));
                }
                if (state.longitude) {
                    setLongitude(parseFloat(state.longitude));
                }
            } catch (error) {
                console.error("Error parsing stored state:", error);
            }
        }

        // Try geolocation in background (non-blocking)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                }
            );
        }
    }, []);

    // Fetch event details immediately when eventId is available (don't wait for validation)
    useEffect(() => {
        if (eventId) {
            fetcheventdetails(eventId);
        }
    }, [eventId])

    // Fetch event list in parallel (for validation, but don't block main content)
    useEffect(() => {
        if (latitude !== null && longitude !== null) {
            fetcheventlist();
        }
    }, [latitude, longitude, emirate, selectedStateId])

    // Validate event after both are fetched (non-blocking)
    useEffect(() => {
        if (eventId && Array.isArray(eventlist) && eventlist.length > 0) {
            const isValid = isEventIdInEventList(eventId);
            setIsEventValid(isValid);
            // If invalid and we have event details, clear them
            if (!isValid && eventdetail.length > 0) {
                setEventDetail([]);
            }
        } else if (eventId && Array.isArray(eventlist) && eventlist.length === 0 && eventdetail.length === 0) {
            // If event list is empty and no event details, mark as invalid
            setIsEventValid(false);
        }
    }, [eventId, eventlist, eventdetail])

    // Scroll to top when eventId changes
    useEffect(() => {
        if (eventId) {
            // Use setTimeout to ensure navigation is complete
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'auto' });
            }, 100);
        }
    }, [eventId])

    // Fetch brand list immediately (independent of other data)
    useEffect(() => {
        fetchGetbrandlist()
    }, [])

    // Fetch related events and vendor events in parallel once event details are loaded
    useEffect(() => {
        if (eventdetail.length > 0 && eventdetail[0]?.event_id && latitude !== null && longitude !== null) {
            // Fetch both in parallel (they're async functions, so they'll run concurrently)
            fetchrelatedevents(eventdetail[0].event_id);
            if (eventdetail[0]?.user_id) {
                fetchvendoreventlist(eventdetail[0].user_id);
            }
        }
    }, [eventdetail, latitude, longitude, emirate, selectedStateId])


    useEffect(() => {
        if (eventdetail.length > 0) {
            const mediaItems = [];

            // Add video first if it exists
            if (eventdetail[0]?.event_video) {
                mediaItems.push({
                    type: "video",
                    src: eventdetail[0].event_video
                });
            }

            // Add images
            const imgs =
                eventdetail[0]?.event_images?.map(img => ({
                    type: "img",
                    src: img.image
                })) || [];

            mediaItems.push(...imgs);

            setMediaItems(mediaItems);

            // Set initial selected media (video first if exists, otherwise first image)
            if (mediaItems.length > 0) {
                setSelectedImage(mediaItems[0].src);
                setSelectedMedia(mediaItems[0]);
            }
        }
    }, [eventdetail]);

    // Timer countdown effect
    useEffect(() => {
        if (!eventdetail[0]?.end_date) return;

        const calculateTimeRemaining = () => {
            // Parse end_date (format: DD-MM-YYYY)
            const [day, month, year] = eventdetail[0].end_date.split("-");
            let endDate = new Date(year, month - 1, day);

            // If end_time exists, add it to the date
            if (eventdetail[0]?.end_time) {
                const [hours, minutes] = eventdetail[0].end_time.split(":");
                endDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
            } else {
                // Default to end of day if no time specified
                endDate.setHours(23, 59, 59, 999);
            }

            const now = new Date();
            const difference = endDate - now;

            if (difference <= 0) {
                setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
                return;
            }

            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            setTimeRemaining({ days, hours, minutes, seconds });
        };

        // Calculate immediately
        calculateTimeRemaining();

        // Update every second
        const interval = setInterval(calculateTimeRemaining, 1000);

        return () => clearInterval(interval);
    }, [eventdetail]);

    // Shimmer Component
    const ShimmerEventDetails = () => (
        <div className="offers-main-layout">
            <LeftSection hideVideos={true} />
            <main className="offers-middle-section">
                {/* Section 1 shimmer */}
                <div className="offer-section1 event-detail-offersection">
                    <div className="offer-left">
                        <div className="offer_bgimg1 shimmer-box shimmer-hero-image"></div>
                    </div>
                    <div className="offer-right">
                        <div className="offer-section1-header shimmer-header">
                            <div className="shimmer-circle shimmer-icon"></div>
                        </div>
                        <div className="shimmer-line shimmer-title"></div>
                        <div className="carousel-container shimmer-carousel">
                            <div className="shimmer-box shimmer-carousel-item"></div>
                            <div className="shimmer-box shimmer-carousel-item"></div>
                            <div className="shimmer-box shimmer-carousel-item"></div>
                        </div>
                        <div className="offer-section1-bottom shimmer-button">
                            <div className="shimmer-box shimmer-btn-large"></div>
                        </div>
                    </div>
                </div>

                {/* Location, date, time, price shimmer */}
                <div className="event-detail-location-timerange-amount shimmer-location-info">
                    <div className="event-datail-location-and-timerange">
                        <div className="location-locationpin shimmer-location-row">
                            <div className="shimmer-circle shimmer-icon"></div>
                            <div className="shimmer-line shimmer-text-medium"></div>
                        </div>
                        <div className="date-and-timerange shimmer-date-time">
                            <div className="date-timer shimmer-date-row">
                                <div className="shimmer-circle shimmer-icon"></div>
                                <div className="shimmer-line shimmer-text-medium"></div>
                            </div>
                            <div className="shimmer-line shimmer-text-small"></div>
                        </div>
                    </div>
                    <div className="event-price shimmer-price">
                        <div className="shimmer-circle shimmer-icon"></div>
                        <div className="shimmer-line shimmer-price-text"></div>
                    </div>
                </div>

                {/* Description shimmer */}
                <div className="description shimmer-description">
                    <div className="shimmer-line shimmer-text-full"></div>
                    <div className="shimmer-line shimmer-text-partial"></div>
                    <div className="shimmer-line shimmer-text-partial-90"></div>
                </div>

                {/* Tabs shimmer */}
                <div className="offer-tabs shimmer-tabs">
                    <div className="shimmer-line shimmer-tab"></div>
                    <div className="shimmer-line shimmer-tab"></div>
                    <div className="shimmer-line shimmer-tab"></div>
                </div>

                {/* Tab content shimmer */}
                <div className="description1 shimmer-tab-content">
                    <div className="shimmer-line shimmer-text-full"></div>
                    <div className="shimmer-line shimmer-text-partial-95"></div>
                    <div className="shimmer-line shimmer-text-partial-90"></div>
                </div>

                {/* Offered by shimmer */}
                <h6 className="offered-by shimmer-section-title">
                    <div className="shimmer-line shimmer-title-small"></div>
                </h6>
                <div className="offered-by-container shimmer-offered-by">
                    <div className="offered-by-img-content-container shimmer-offered-by-content">
                        <div className="shimmer-circle shimmer-vendor-image"></div>
                        <div className="offered-by-content shimmer-vendor-info">
                            <div className="shimmer-line shimmer-text-medium"></div>
                            <div className="shimmer-line shimmer-rating-text"></div>
                            <div className="shimmer-line shimmer-text-small"></div>
                        </div>
                    </div>
                </div>

                {/* You may like shimmer */}
                <h6 className="you-may-like shimmer-section-title">
                    <div className="shimmer-line shimmer-title-medium"></div>
                </h6>
                <div className="you-may-like-section shimmer-carousel-section">
                    <div className="shimmer-carousel-items">
                        {[1, 2, 3].map((item) => (
                            <div key={item} className="offer-card shimmer-carousel-card">
                                <div className="offer-img-wrapper shimmer-box shimmer-card-image"></div>
                                <div className="offer-details shimmer-card-details">
                                    <div className="shimmer-line shimmer-text-small"></div>
                                    <div className="shimmer-line shimmer-text-medium"></div>
                                    <div className="shimmer-line shimmer-text-small"></div>
                                    <div className="shimmer-line shimmer-text-small"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );

    // Show shimmer only if event details haven't loaded yet
    // Don't block on validation - show data optimistically
    if (eventdetail.length === 0) {
        return (
            <div>
                <Navbar />
                <ShimmerEventDetails />
            </div>
        );
    }

    // If validation completed and event is invalid, show error
    if (Array.isArray(eventlist) && eventlist.length > 0 && !isEventValid && eventdetail.length === 0) {
        return (
            <div>
                <Navbar />
                <div className="offers-main-layout">
                    <LeftSection />
                    <main className="offers-middle-section">
                        <div style={{ padding: '2rem', textAlign: 'center' }}>
                            <h3>Event Not Found</h3>
                            <p>This event is not available in the current event list.</p>
                        </div>
                    </main>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Navbar />
            <div className="offers-main-layout">
                <LeftSection hideVideos={true} />
                <main className="offers-middle-section">

                    <div className="offer-section1 event-detail-offersection">
                        <div className="offer-left">
                            {selectedMedia && (
                                <div className="offer_bgimg1">
                                    {selectedMedia.type === "video" ? (
                                        <video
                                            src={selectedMedia.src}
                                            controls
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                display: "block"
                                            }}
                                        />

                                    ) : (
                                        <div
                                            style={{
                                                backgroundImage: `url(${selectedImage})`,
                                                width: "100%",
                                                height: "100%",
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                borderRadius: "8px",
                                                position: "relative"
                                            }}
                                        >
                                            {eventdetail[0]?.end_date && (
                                                <div className="event-detail-timer">
                                                    <div className="event-detail-timer-item">
                                                        <div className="event-detail-timer-value">{String(timeRemaining.days).padStart(2, '0')}</div>
                                                        <div className="event-detail-timer-label">Days</div>
                                                    </div>
                                                    <div className="event-detail-timer-separator">:</div>
                                                    <div className="event-detail-timer-item">
                                                        <div className="event-detail-timer-value">{String(timeRemaining.hours).padStart(2, '0')}</div>
                                                        <div className="event-detail-timer-label">Hr</div>
                                                    </div>
                                                    <div className="event-detail-timer-separator">:</div>
                                                    <div className="event-detail-timer-item">
                                                        <div className="event-detail-timer-value">{String(timeRemaining.minutes).padStart(2, '0')}</div>
                                                        <div className="event-detail-timer-label">Min</div>
                                                    </div>
                                                    <div className="event-detail-timer-separator">:</div>
                                                    <div className="event-detail-timer-item">
                                                        <div className="event-detail-timer-value">{String(timeRemaining.seconds).padStart(2, '0')}</div>
                                                        <div className="event-detail-timer-label">Sec</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="offer-right">
                            {/* Header row */}
                            <div className="offer-section1-header">

                                <div className="offer-section1-heart-upload">
                                    {/* <img src={heartplus} alt="heart" />
                                    <img src={upload} alt="upload" /> */}
                                </div>
                            </div>

                            {/* H3 content below */}
                            <h3>{eventdetail[0]?.title}</h3>
                            <div className="carousel-container">
                                {
                                    mediaItems.length === 1 ? (
                                        // Single media (image or video)
                                        mediaItems[0].type === "video" ? (
                                            <video
                                                src={mediaItems[0].src}
                                                muted
                                                playsInline
                                                className="single-image"
                                                style={{
                                                    objectFit: "cover",
                                                    borderRadius: "12px"
                                                }}
                                            />
                                        ) : (
                                            <img
                                                src={mediaItems[0].src}
                                                alt="single-media"
                                                className="single-image"
                                            />
                                        )
                                    ) : (
                                        // Carousel for 2 or more media items
                                        <>
                                            {mediaItems.length > 3 && (
                                                <img
                                                    src={leftarrow}
                                                    alt="left"
                                                    className="arrows"
                                                    onClick={() => sliderRef.current.slickPrev()}
                                                />
                                            )}

                                            <div className="slider-wrapper">
                                                <Slider ref={sliderRef} {...settings}>
                                                    {mediaItems.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className="carousel-item"
                                                            onClick={() => {
                                                                setSelectedImage(item.src);
                                                                setSelectedMedia(item);
                                                            }}
                                                        >
                                                            {item.type === "video" ? (
                                                                <video
                                                                    src={item.src}
                                                                    muted
                                                                    playsInline
                                                                    style={{
                                                                        width: "100%",
                                                                        aspectRatio: "16/16",
                                                                        objectFit: "cover",
                                                                        borderRadius: "8px"
                                                                    }}
                                                                />
                                                            ) : (
                                                                <img src={item.src} alt={`media-${index}`} />
                                                            )}
                                                        </div>
                                                    ))}
                                                </Slider>
                                            </div>

                                            {mediaItems.length > 3 && (
                                                <img
                                                    src={rightarrow}
                                                    alt="right"
                                                    className="arrows"
                                                    onClick={() => sliderRef.current.slickNext()}
                                                />
                                            )}
                                        </>
                                    )
                                }
                            </div>

                            <div className="offer-section1-bottom">
                                <button className="buy-ticket-button" onClick={() => setDownloadPopupOpen(true)}>
                                    Buy Tickets
                                </button>

                            </div>
                        </div>
                    </div>

                    <div className="event-detail-location-timerange-amount">
                        <div className="event-datail-location-and-timerange">
                            <div className="location-locationpin">
                                <img src={locationPin} alt="location" className="locationpinicon" />
                                <p>{eventdetail[0]?.location_name}</p>
                            </div>
                            <div className="date-and-timerange">
                                <div className="date-timer">
                                    <img src={timer} alt="timer" className="timericon" />
                                    <p>
                                        {eventdetail[0]?.start_date === eventdetail[0]?.end_date
                                            ? formatDate(eventdetail[0]?.start_date)
                                            : `${formatDate(eventdetail[0]?.start_date)} - ${formatDate(eventdetail[0]?.end_date)}`}
                                    </p>
                                </div>
                                {eventdetail[0]?.start_time && eventdetail[0]?.end_time && (
                                    <div className="time-range">
                                        <p>
                                            {formatTime(eventdetail[0]?.start_time)} - {formatTime(eventdetail[0]?.end_time)}
                                        </p>
                                    </div>
                                )}
                            </div>

                        </div>
                        {Number(eventdetail[0]?.price_from) > 0 && (
                            <div className="event-price">
                                <img src={ticket} alt="ticket" className="locationpinicon" />
                                <p className="price-label">
                                    {eventdetail[0]?.price_to != null && <span id="from">From </span>}
                                    <span>AED {eventdetail[0]?.price_from}</span>
                                </p>
                            </div>
                        )}
                    </div>
                    <div className="description">
                        {eventdetail[0]?.description && (() => {
                            const descLimit = 60; // number of characters before truncation
                            const descTruncateLength = 200;

                            const shouldTruncate = eventdetail[0].description.length > descTruncateLength;

                            return (
                                <p className={`coupon-description-text ${expand ? "expanded" : ""}`}>
                                    {expand
                                        ? eventdetail[0].description
                                        : shouldTruncate
                                            ? `${eventdetail[0].description.substring(0, descTruncateLength)}... `
                                            : eventdetail[0].description
                                    }

                                    {shouldTruncate && (
                                        <span
                                            className="coupon-description-toggle"
                                            onClick={() => setExpand(!expand)}
                                        >
                                            {expand ? "Less" : "More"}
                                        </span>
                                    )}
                                </p>
                            );
                        })()}
                    </div>

                    <div>
                        {/* Tabs */}
                        <div className="offer-tabs">
                            <button
                                className={activeTab === "Details" ? "active" : ""}
                                onClick={() => setActiveTab("Details")}
                            >
                                Details
                            </button>
                            <button
                                className={activeTab === "Guide" ? "active" : ""}
                                onClick={() => setActiveTab("Guide")}
                            >
                                Guide
                            </button>
                            <button
                                className={activeTab === "T&Cs" ? "active" : ""}
                                onClick={() => setActiveTab("T&Cs")}
                            >
                                T&Cs
                            </button>
                            {/* {hasAmenities && (
                                                    <button
                                                        className={activeTab === "Amenities" ? "active" : ""}
                                                        onClick={() => setActiveTab("Amenities")}
                                                    >
                                                        Amenities
                                                    </button>
                                                )} */}
                        </div>

                        <div className="description1">
                            {activeTab === "Details" && (
                                <div className="coupon-details">
                                    {eventdetail[0]?.details && (() => {
                                        const descLimit = 60;            // minimum length to consider
                                        const descTruncateLengthdetails = 220;  // actual truncate length

                                        // Show More/Less ONLY if text exceeds truncate length
                                        const shouldTruncate =
                                            eventdetail[0].details.length > descTruncateLengthdetails;

                                        return (
                                            <p className={`coupon-description-text ${expand ? "expanded" : ""}`}>
                                                {expanddetailstab
                                                    ? eventdetail[0].details
                                                    : shouldTruncate
                                                        ? `${eventdetail[0].details.substring(0, descTruncateLengthdetails)}... `
                                                        : eventdetail[0].details
                                                }

                                                {shouldTruncate && (
                                                    <span
                                                        className="coupon-description-toggle"
                                                        onClick={() => setExpandDetailsTab(!expanddetailstab)}
                                                    >
                                                        {expanddetailstab ? "Less" : "More"}
                                                    </span>
                                                )}
                                            </p>
                                        );
                                    })()}
                                </div>

                            )}

                            {activeTab === "Guide" && (
                                <div className="coupon-details">
                                    <p
                                        ref={descRef}
                                        className={`coupon-description-text ${expand ? "expanded" : ""}`}
                                    >
                                        {eventdetail[0]?.guide}
                                    </p>

                                    {showToggle && (
                                        <span
                                            className="coupon-description-toggle"
                                            onClick={() => setExpand(!expand)}
                                        >
                                            {expand ? "Less" : "More"}
                                        </span>
                                    )}
                                </div>
                            )}
                            {activeTab === "T&Cs" && (
                                <div className="coupon-details">
                                    <p
                                        ref={descRef}
                                        className={`coupon-description-text ${expand ? "expanded" : ""}`}
                                    >
                                        {eventdetail[0]?.terms_and_conditions}
                                    </p>

                                    {showToggle && (
                                        <span
                                            className="coupon-description-toggle"
                                            onClick={() => setExpand(!expand)}
                                        >
                                            {expand ? "Less" : "More"}
                                        </span>
                                    )}
                                </div>
                            )}


                            {/* {activeTab === "T&Cs" && <p>{eventdetail[0].terms_and_conditions}</p>} */}
                            {activeTab === "Amenities" && hasAmenities && (
                                <ul>
                                    {eventdetail[0].amenities.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>


                    <h6 className="offered-by">Organized by</h6>
                    <div className="offered-by-container">
                        <div className="offered-by-img-content-container">
                            <Link
                                to={`/vendordetails/${eventdetail[0]?.user_id}`}
                                className="remove-underline"
                            >
                                <img src={eventdetail[0]?.user_image} alt="Vendor" className="offered-by-rotana1" />

                            </Link>
                            <div className="offered-by-content">
                                <div className="offered-by-heading">
                                    <Link
                                        to={`/vendordetails/${eventdetail[0]?.user_id}`}
                                        className="remove-underline"
                                    >
                                        <h6>{eventdetail[0]?.user_name}</h6>
                                    </Link>
                                    <button className="follow-btn" onClick={()=>setDownloadPopupOpen(true)}>Follow</button>
                                </div>
                                <div className="offer-section1-bottom">
                                    <div className="rating-container">
                                        <span className="rating">5.0</span>
                                        <div className="stars">
                                            <img src={star} alt="star" className="star" />
                                            <img src={star} alt="star" className="star" />
                                            <img src={star} alt="star" className="star" />
                                            <img src={star} alt="star" className="star" />
                                            <img src={star} alt="star" className="star" />
                                        </div>
                                        <span className="reviews">(1 reviews)</span>
                                    </div>
                                </div>
                                <p className="location">{city}, {state}</p>
                            </div>
                        </div>
                    </div>

                    {(() => {
                        // Filter out the current event from the vendor events list
                        const filteredVendorEvents = vendoreventlist && Array.isArray(vendoreventlist) && vendoreventlist.length > 0
                            ? vendoreventlist.filter(item =>
                                item.event_id && Number(item.event_id) !== Number(eventId)
                            )
                            : [];

                        // Only show section if there are filtered events
                        if (filteredVendorEvents.length === 0) return null;

                        return (
                            <>
                                <h6 className="you-may-like">Similar Events from Etihad Arena</h6>
                                <div className="vendor-events-section">
                                    <div className="vendor-events-grid-desktop">
                                        {filteredVendorEvents.map((item, index) => {
                                            return (
                                                <Link
                                                    key={index}
                                                    to={`/eventdetails/${item.event_id}`}
                                                    className="remove-underline"
                                                    onClick={(e) => handleEventClick(e, item.event_id)}
                                                >
                                                    <div className="offer-card vendor-event-card-horizontal">
                                                        <div className="vendor-event-image-wrapper">
                                                            <img src={item.event_image} alt={item.title} />
                                                        </div>
                                                        <div className="vendor-event-details-wrapper">
                                                            <p className="offer-location">
                                                                <span>
                                                                    <img src={locationPinblack} alt="logo" className="locationpinicon" />
                                                                </span>
                                                                <span>{item.location_name}</span>
                                                            </p>
                                                            <h4>{item.title}</h4>
                                                            <p className="limited-deals-distance">
                                                                {item.start_date === item.end_date
                                                                    ? formatDate(item.start_date)
                                                                    : `${formatDate(item.start_date)} - ${formatDate(item.end_date)}`}
                                                            </p>
                                                            {Number(item.price_from) > 0 && (
                                                                <p className="event-list-price">
                                                                    {item.price_to != null && <span id="from">From </span>}
                                                                    <span>AED {item.price_from}</span>
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Link>
                                            );
                                        })}
                                    </div>
                                    <div className="vendor-events-list-mobile">
                                        {filteredVendorEvents.map((item, index) => {
                                            return (
                                                <Link
                                                    key={index}
                                                    to={`/eventdetails/${item.event_id}`}
                                                    className="remove-underline"
                                                    onClick={(e) => handleEventClick(e, item.event_id)}
                                                >
                                                    <div className="vendor-event-card-horizontal vendor-event-card-mobile">
                                                        <div className="vendor-event-image-wrapper">
                                                            <img src={item.event_image} alt={item.title} />
                                                        </div>
                                                        <div className="vendor-event-details-wrapper">
                                                            <p className="offer-location">
                                                                <span>
                                                                    <img src={locationPinblack} alt="logo" className="locationpinicon" />
                                                                </span>
                                                                <span>{item.location_name}</span>
                                                            </p>
                                                            <h4>{item.title}</h4>
                                                            <p className="limited-deals-distance">
                                                                {item.start_date === item.end_date
                                                                    ? formatDate(item.start_date)
                                                                    : `${formatDate(item.start_date)} - ${formatDate(item.end_date)}`}
                                                            </p>
                                                            {Number(item.price_from) > 0 && (
                                                                <p className="event-list-price">
                                                                    {item.price_to != null && <span id="from">From </span>}
                                                                    <span>AED {item.price_from}</span>
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Link>
                                            );
                                        })}
                                    </div>
                                </div>
                            </>
                        );
                    })()}

                    <h6 className="you-may-like">Events You Might like</h6>
                    <div className="you-may-like-section">
                        <Slider ref={youMayLikeSliderRef} {...offerSettings}>
                            {relatedevents.map((item, index) => {

                                return (
                                    <Link
                                        to={`/eventdetails/${item.event_id}`}
                                        className="remove-underline"
                                        onClick={(e) => handleEventClick(e, item.event_id)}
                                    >
                                        <div className="offer-card">
                                            <div className="offer-img-wrapper">
                                                <img src={item.event_image} alt="festive season" />
                                            </div>
                                            <div className="offer-details eventyoumightlike">
                                                <p className="offer-location">
                                                    <span>
                                                        <img src={locationPinblack} alt="logo" className="locationpinicon" />
                                                    </span>
                                                    <span>{item.location_name}</span>
                                                </p>
                                                <h4>{item.title}</h4>
                                                <p className="limited-deals-distance">
                                                    {item.start_date === item.end_date
                                                        ? formatDate(item.start_date)
                                                        : `${formatDate(item.start_date)} - ${formatDate(item.end_date)}`}
                                                </p>
                                                {Number(item.price_from) > 0 && (
                                                    <p className="event-list-price">
                                                        {item.price_to != null && <span id="from">From </span>}
                                                        <span>AED {item.price_from}</span>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })}
                        </Slider>
                    </div>
                </main>
            </div>


            {downloadPopupOpen && (
                <>
                    <div className="overlay" onClick={() => setDownloadPopupOpen(false)}></div>
                    <div className="download-popup-drawer">
                        <div className="pop-up-img">
                            <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                        </div>
                        <div className="popup-header">
                            <div className="pop-up-download">
                                <div className="hayaticon">
                                    <img src={hayatlogo} alt="Hayat In Logo" />
                                    <div className="close-btn">
                                        <img src={xmark} alt="xmark" className="close-popup" onClick={() => setDownloadPopupOpen(false)} />
                                    </div>
                                </div>
                                <h4 className="download-hayat">Download Our App </h4>
                                <p id="App-description">
                                    Scan the QR code with your phone and open Hayat In instantly
                                    Your gateway to discovering the city in one tap.
                                </p>

                                <div className="store-buttons">
                                    <div className="app_qr">
                                        <a
                                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={app_store} alt="App Store" />
                                        </a>

                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={play_store} alt="Google Play" />
                                        </a>
                                    </div>


                                    <div className="app_qr">
                                        <img className="qr" src={qr} alt="QR code" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </>
            )}
        </div>
    )

}


export default EventDetails